import { HTTP } from '../../http-common';

export const state = {
  viewbarEnabled: false,
  impersonating: {},
  loadingState: false,
};

export const getters = {
  viewbarEnabled: (state) => {
    return state.viewbarEnabled;
  },
  impersonating: (state) => {
    return state.impersonating;
  },
  loadingState: (state) => {
    return state.loadingState;
  },
};

export const mutations = {
  RESET_IMPERSONATION(state) {
    state.impersonating = {};
    state.viewbarEnabled = false;
  },
  TOGGLE_VIEWBAR(state) {
    state.viewbarEnabled = !state.viewbarEnabled;
  },
  SHOW_VIEWBAR(state) {
    state.viewbarEnabled = true;
  },
  SET_IMPERSONATING(state, user) {
    state.impersonating = user;
  },
};

const actions = {
  getCurrentDealerCustomers() {
    return new Promise((resolve, reject) => {
      HTTP.get(`Impersonate/GetCurrentDealerCustomers`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getDealerMembers() {
    return new Promise((resolve, reject) => {
      HTTP.get(`Impersonate/GetDealerMembers`)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  showLoading({ commit }) {
    commit('SHOW_LOADING');
  },
  hideLoading({ commit }) {
    commit('HIDE_LOADING');
  },

  processImpersonation({ state, rootState, dispatch }) {
    let data = {
      userType: 'dealer',
      impersonatedID: state.impersonating.dealerIDno,
    };

    return new Promise((resolve, reject) => {
      HTTP.post(`Impersonate/Impersonate`, data)
        .then((data) => {
          dispatch('orders/getDealerFromEmail', {}, { root: true }).then(
            (res) => {
              rootState.orders.dealer.dealer = res;
              resolve(data);
            }
          );
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  revokeImpersonation({ commit, rootState, dispatch }) {
    let data = {
      userType: 'dealer',
      impersonatedID: -1,
    };

    return new Promise((resolve, reject) => {
      HTTP.post(`Impersonate/Impersonate`, data)
        .then((data) => {
          dispatch('orders/getDealerFromEmail', {}, { root: true }).then(
            (res) => {
              rootState.orders.dealer.dealer = res;
              commit('SET_IMPERSONATING', {});
              resolve(data);
            }
          );
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  isImpersonating({ commit }, impersonatedID) {
    return new Promise((resolve, reject) => {
      HTTP.get(`Impersonate/IsImpersonating/${impersonatedID}`)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getViewbarStatus({ dispatch, commit, state }) {
    return state.viewbarEnabled;
  },

  enableViewBar({ commit, state }) {
    commit('SHOW_VIEWBAR');
  },

  toggleViewBar({ commit, state }) {
    commit('TOGGLE_VIEWBAR', !state.viewbarEnabled);
  },
  setImpersonatingAs({ commit }, user) {
    commit('SET_IMPERSONATING', user);
  },
  resetImpersonation({ commit, dispatch }) {
    dispatch('revokeImpersonation');
    commit('RESET_IMPERSONATION');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
